interface StatCardProps {
  title: string
  value: number
  className?: string
}

export function StatCard({ title, value, className = '' }: StatCardProps) {
  return (
    <div className={`bg-card rounded-lg border border-border p-4 ${className}`}>
      <p className="text-sm text-muted-foreground">{title}</p>
      <p className="text-2xl font-bold text-foreground">{value.toLocaleString()}</p>
    </div>
  )
}
